import { Heart, ChevronRight, BookOpen, Users, Award, Star, ArrowRight, Shield, Globe } from "lucide-react";
import { siteStats, events, committeeMembers } from "../data";
import logo from "../assets/icons/logo.webp"; 
import { Phone, MessageCircleMore } from "lucide-react";
import { useEffect, useState } from "react";

import heroBg1 from "../assets/bg/bg-hero-1.webp";
import heroBg2 from "../assets/bg/bg-hero-2.webp";
import heroBg3 from "../assets/bg/bg-hero-3.webp";
import heroBg4 from "../assets/bg/bg-hero-4.webp";
import heroBg5 from "../assets/bg/bg-hero-5.webp";
import heroBg6 from "../assets/bg/bg-hero-6.webp";


const programs = [
  { icon: BookOpen, title: "Formal Education Support", desc: "Full school fee sponsorship, books, uniforms, and stationery for enrolled children from Classes I–XII." },
  { icon: Star, title: "Merit Scholarship Programme", desc: "Annual scholarships recognising academic excellence and encouraging higher education aspirations." },
  { icon: Heart, title: "Health & Nutrition", desc: "Regular health check-ups, nutritious mid-day meals, and psychological counselling support." },
  { icon: Users, title: "Skill & Vocational Training", desc: "Practical workshops in digital literacy, spoken English, and vocational skills for older students." },
  { icon: Globe, title: "Community Outreach", desc: "Awareness camps, parent education programmes, and neighbourhood literacy drives." },
  { icon: Shield, title: "Child Rights Advocacy", desc: "Legal support and advocacy to protect enrolled children from child labour and abuse." },
];

export default function Home({ onNavigate }) {
  const featuredEvents = events.slice(0, 3);

const heroImages = [heroBg1, heroBg2, heroBg3, heroBg4, heroBg5, heroBg6];

const [currentBg, setCurrentBg] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentBg((prev) => (prev + 1) % heroImages.length);
  }, 3500); 

  return () => clearInterval(interval);
}, []);


  return (
    <div>
      {/* ===== HERO ===== */}
      <section style={{
        minHeight: "100vh", display: "flex", alignItems: "center",
        background: "linear-gradient(135deg, #0D2B1D 0%, #1B4332 45%, #2D6A4F 100%)",
        position: "relative", overflow: "hidden",
        paddingTop: 68,
 backgroundImage: `
  linear-gradient(rgba(13,43,29,0.82), rgba(27,67,50,0.82)),
  url(${heroImages[currentBg]})
`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
      }}>
   
{/* Top right golden academic rings */}
<div
  style={{
    position: "absolute",
    top: "-120px",
    right: "-120px",
    width: 420,
    height: 420,
    borderRadius: "50%",
    border: "2px solid rgba(255,215,0,0.18)",
    pointerEvents: "none",
  }}
/>

<div
  style={{
    position: "absolute",
    top: "-40px",
    right: "40px",
    width: 280,
    height: 280,
    borderRadius: "50%",
    border: "2px dashed rgba(255,215,0,0.25)",
    pointerEvents: "none",
  }}
/>

{/* Floating scholarship glow */}
<div
  style={{
    position: "absolute",
    top: "25%",
    right: "15%",
    width: 120,
    height: 120,
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(255,215,0,0.25), transparent 70%)",
    pointerEvents: "none",
  }}
/>

{/* Bottom left education wave */}
<div
  style={{
    position: "absolute",
    bottom: "-180px",
    left: "-120px",
    width: 450,
    height: 450,
    borderRadius: "50%",
    background:
      "linear-gradient(135deg, rgba(255,215,0,0.12), rgba(64,145,108,0.15))",
    pointerEvents: "none",
  }}
/>

{/* Small floating dots */}
<div
  style={{
    position: "absolute",
    top: "35%",
    left: "8%",
    width: 14,
    height: 14,
    borderRadius: "50%",
    background: "#FFD700",
    opacity: 0.5,
  }}
/>

<div
  style={{
    position: "absolute",
    top: "42%",
    left: "12%",
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: "#ffffff",
    opacity: 0.6,
  }}
/>


      
        <div className="container" style={{ padding: "2rem 1.5rem", position: "relative" }}>
          <div style={{ maxWidth: 680 }}>
            <span className="eyebrow" style={{ display: "block", marginBottom: "1.25rem" }}>
              <img
  src={logo}
  alt="Birati Child Care"
  style={{
    width: 135,
    height: 135,
    borderRadius: "50%",
    objectFit: "cover",
    flexShrink: 0,
  }}
/> <br/>
 Govt. Regd- S0027121 of 2022-23  
            </span>
         
            <p className="body-lg" style={{ color: "rgba(255,255,255,0.75)", marginBottom: "2.5rem", maxWidth: 540 }}>
            Aiming to carve the deprived young minds with knowledge intellect.....
            </p>
            
            {/* Trust badges */}
            <div style={{ display: "flex", gap: "1.5rem", flexWrap: "wrap", marginTop: "0.5rem" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "0.4rem", color: "rgba(184, 187, 36, 0.95)", fontSize: "1.5rem", fontFamily: "var(--font-label)" }}>
              To help needy, underprivileged students about their Education, Health, Social Awareness etc.....
                </div>
            </div>
          </div>
        </div>

        {/* Ribbon at bottom */}
        <div className="ribbon-divider" style={{ position: "absolute", bottom: 0, left: 0, right: 0 }} />
      </section>






      {/* ===== ABOUT ===== */}
      <section className="section" style={{ background: "var(--white)" }}>
        <div className="container">
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: "4rem", alignItems: "center" }}>
            <div>
              <span className="eyebrow">Our Story</span>
              <h2 className="display-lg" style={{ margin: "0.75rem 0 1.25rem" }}>
                A Single Room.<br />
                <em style={{ color: "var(--forest-mid)" }}>A Thousand Dreams.</em>
              </h2>
              <p style={{ color: "var(--gray)", marginBottom: "1rem", lineHeight: 1.8 }}>
                In March 2022, Mr. Shibsankar Roy started Birati Child Care Foundation in a single rented room with 12 children and one blackboard. His vision was simple: no child in Birati should miss school because of poverty.
              </p>
              <p style={{ color: "var(--gray)", marginBottom: "2rem", lineHeight: 1.8 }}>
                Today, BCF operates a dedicated learning centre, serves over 100+ active students. We are funded by individual donors, corporate CSR, and grants—with 100% of donations going directly to child welfare.
              </p>


<button className="btn btn-primary" onClick={() => onNavigate("students")}>
                Find Students <ArrowRight size={16} />
              </button>
              <br/> <br/>
              <button className="btn btn-primary" onClick={() => onNavigate("committee")}>
                Meet Committee <ArrowRight size={16} />
              </button>
              <br/><br/>
<button className="btn btn-primary" onClick={() => onNavigate("events")}>
                See Events <ArrowRight size={16} />
              </button>

            </div>
            {/* Visual card */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
              {[
                { label: "Students Currently Enrolled", value: "100+", icon: "📚" },
                { label: "Classes Supported", value: "I–XII", icon: "🎓" },
                { label: "Volunteers", value: "50+", icon: "🤝" },
                { label: "Years of Impact", value: "4+", icon: "⭐" },
              ].map((item, i) => (
                <div key={i} style={{
                  background: i % 2 === 0 ? "var(--forest)" : "var(--cream)",
                  borderRadius: "var(--radius-lg)", padding: "1.75rem 1.5rem",
                  textAlign: "center",
                }}>
                  <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>{item.icon}</div>
                  <div style={{ fontFamily: "var(--font-display)", fontSize: "1.8rem", fontWeight: 700, color: i % 2 === 0 ? "var(--gold)" : "var(--forest)", lineHeight: 1 }}>{item.value}</div>
                  <div style={{ fontSize: "0.8rem", color: i % 2 === 0 ? "rgba(255,255,255,0.65)" : "var(--gray)", marginTop: "0.4rem", fontFamily: "var(--font-label)" }}>{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      

     
     

      {/* ===== CTA STRIP ===== */}
      <section style={{ background: "linear-gradient(135deg, var(--forest) 0%, var(--forest-mid) 100%)", padding: "5rem 0" }}>
        <div className="container" style={{ textAlign: "center" }}>
          <span className="eyebrow" style={{ marginBottom: "1rem", display: "block" }}>Make a Difference Today</span>
          <h2 className="display-lg" style={{ color: "#fff", marginBottom: "1.25rem" }}>
            Build <em style={{ color: "var(--gold)" }}>a Child's Entire Year.</em>
          </h2>
          <p style={{ color: "rgba(255,255,255,0.72)", fontSize: "1.05rem", maxWidth: 480, margin: "0 auto 2.5rem" }}>
            Your monthly contribution sponsors school fees, books, uniforms, and nutritious meals—everything a child needs to thrive.
          </p>
          <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
            <button className="btn btn-primary" onClick={() => onNavigate("contact")} style={{ padding: "0.9rem 2.2rem", fontSize: "1.05rem" }}>
              <Heart size={17} /> Join Now
            </button>
            
{/*
<button className="btn btn-white" onClick={() => onNavigate("certifications")} style={{ padding: "0.9rem 2.2rem", fontSize: "1.05rem" }}>
              <Award size={17} /> View Our Credentials
            </button>
*/}

          </div>
        </div>
      </section>
    </div>
  );
}
